import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'

import { Link } from '~/components'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [
  { screen: '(max-width: 767px)', width: '42px' },
  { screen: '(min-width: 768px)', width: '54px' },
]

export default function BackButton({
  href,
  onClick,
  imageClassName,
}: {
  href?: string
  onClick?: () => void
  imageClassName?: string
}): React.ReactElement {
  const { t } = useTranslation(['mathVault'])

  const children = (
    <button
      className="w-10 h-10 lg:w-14 lg:h-14 transition duration-300 transform active:scale-80 rounded-full top-0 left-0"
      onClick={onClick}
    >
      <ResponsiveImage
        alt={t('mathVault:iconAlts.back3D')}
        height={174}
        imageClassName={imageClassName}
        imageWidths="150"
        loading="eager"
        mediaQuery={mediaQuery}
        srcKey="Math Vault/icons/back-3D.png"
        width={172}
      />
    </button>
  )

  return (
    <>
      {href ? (
        <Link className="flex items-center" to={href}>
          {children}
        </Link>
      ) : (
        <Fragment>{children}</Fragment>
      )}
    </>
  )
}
